// ⚠️ AUTO-GENERATED — DO NOT EDIT MANUALLY
// Source: ./svg/IconDownload.svg — regenerate with `nx run creditflowresearch-uilib:icons-generate --write`
import BaseIcon from './BaseIcon';
import type { IIconProps } from './types';

const IconDownload = (props: IIconProps) => (
  <BaseIcon viewBox="0 0 16 16" fill="currentColor" { ...props }>
    <path d="M14.0332 4.65212C13.5104 4.1464 12.6578 4.1464 12.135 4.65212L9.34074 7.35327V1.29882C9.34074 0.584096 8.73885 0 8.00001 0C7.26116 0 6.65735 0.584096 6.65735 1.29882V7.35327L3.86503 4.65212C3.34225 4.1464 2.48958 4.1464 1.96679 4.65212C1.44401 5.15784 1.44401 5.98266 1.96679 6.48838L7.05089 11.4065C7.57367 11.9103 8.42634 11.9103 8.94913 11.4065L14.0332 6.48838C14.5541 5.98266 14.5541 5.15784 14.0332 4.65212Z" />
    <path d="M16 14.7012C16 13.9883 15.3962 13.4042 14.6573 13.4042H1.34073C0.601881 13.4042 0 13.9883 0 14.7012C0 15.4159 0.601881 16 1.34073 16H14.6573C15.3962 16 16 15.4159 16 14.7012Z" />
  </BaseIcon>
);

export default IconDownload;
